import { jsx as m } from "react/jsx-runtime";
import { forwardRef as D, useMemo as F, useEffect as n } from "react";
import { u as R } from "../../../index-e4ghXvm8.js";
import { useDebounce as q } from "@forma/forma-ui-kit";
import y from "../FillFolder/index.js";
const z = "forma-filling__fill-form__groups", A = "forma-filling__fill-form__counteragents", O = {
  groups: z,
  counteragents: A
}, L = D(({
  values: a,
  folders: t,
  selected: V,
  onChange: j,
  onErrors: N,
  onChangeSelected: v,
  onChangeValid: x,
  showCount: E,
  showGroupName: S,
  showSelect: w
}, l) => {
  const { register: J, watch: f, control: M, reset: g, getValues: p, setValue: d, trigger: _, formState: { errors: s, isValid: i } } = R({
    mode: "onChange",
    defaultValues: a
  });
  l && (l.current = { reset: g, getValues: p, setValue: d, revalidate: _ });
  const c = F(() => t == null ? void 0 : t.flatMap(({ tattrs: r }) => r), [t]);
  n(() => {
    if (c) {
      const r = p(), o = {};
      Object.keys(r).forEach((e) => {
        r[e] && !c.find(({ id: u }) => u === e) ? o[e] = "" : o[e] = r[e];
      }), g(o);
    }
    setTimeout(() => _(), 100);
  }, [JSON.stringify(c)]);
  const T = F(() => i, [i]);
  n(() => {
    x(i);
  }, [T]);
  const b = Object.keys(s).reduce((r, o) => {
    var e;
    return { ...r, [o]: ((e = s[o]) == null ? void 0 : e.message) ?? "" };
  }, {});
  n(() => {
    N(b);
  }, [JSON.stringify(b)]);
  const C = q(j, 50);
  return n(() => {
    const r = f((o) => {
      const e = Object.keys(o).reduce((u, h) => ({ ...u, [h]: o[h] || void 0 }), {});
      C(e);
    });
    return () => r.unsubscribe();
  }, [f]), /* @__PURE__ */ m("div", { className: O.root, children: /* @__PURE__ */ m("div", { className: O.groups, children: t == null ? void 0 : t.map(({ id: r, name: o, tattrs: e }) => e != null && e.length ? /* @__PURE__ */ m(
    y,
    {
      id: r,
      name: o,
      tattrs: e,
      register: J,
      errors: s,
      control: M,
      setValue: d,
      values: a,
      showGroupName: S,
      showCount: E,
      showSelect: w,
      onChangeSelected: v,
      selected: V
    },
    r
  ) : null) }) });
});
export {
  L as default
};
